//@flow
import * as Immutable from 'immutable';

import { LocationId } from 'common/models/flow/LocationId';
import type { LocationIdModelType } from 'common/models/flow/LocationId';

import StringUtils from 'common/utils/StringUtils';

import I18nHelper from 'common/helpers/I18nHelper';

import {
    validatable,
    validateAll,
    validate,
    softValidateAll
} from 'common/utils/ValidationUtil';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalLocationId extends LocationId {
    static fromJS(json: LocationIdModelType): InternalLocationId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setLocationId(locationId: string): this {
        return super.setLocationId(locationId);
    }

    validateLocationId() {
        if (
            StringUtils.isEmpty(this.locationId) ||
            StringUtils.isEmpty(this.locationId.trim())
        ) {
            return nsTranslate('entityId.entityIdEmpty', {
                entityNameId: 'masterLocation'
            });
        }
    }
}

export { InternalLocationId as LocationId };
